import React, { FC } from 'react';
import { SectionWrapper } from '../SectionWraper';
import { TableComponent } from '../TableComponent';
import { BusinessSettingsFeesTableRow } from './BusinessSettingsFeesTableRow';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { IFees } from '../../store/merchnts/merchant-interfaces';

const feeTableColumn = [
	{
		key: 'name',
		title: 'Fee Name',
		additionalColumnClassName: 'col-2',
	},
	{
		key: 'value',
		title: 'Fee Value',
		additionalColumnClassName: 'col-2',
	},
	{
		key: 'minFeeAmount',
		title: 'Min Fee Amount',
		additionalColumnClassName: 'w-100px',
	},
];

export const BusinessSettingsFees: FC = () => {
	const { merchantState: { merchantFees }} = useMerchants();

	return (
		<SectionWrapper
			title="Fees"
			isCardBody
		>
			<TableComponent
				column={feeTableColumn}
				tableData={merchantFees}
				getRowComponent={(el: IFees): JSX.Element => (
					<BusinessSettingsFeesTableRow key={el?.id} {...el}/>
				)}
			/>

		</SectionWrapper>
	);
};
